var scrollToAnchorOffSet = 75;

function LocaleSet(newLanguage) {

    var curCookie = Cookies.get('Locale');
    if (curCookie != newLanguage) {
        console.log('Switching lang to : %o ', newLanguage);
        // Set the cookie
        Cookies.set('Locale', newLanguage);
    } else {
        //console.log('Skipping cookie write as already set');
    }

}
function AgeGateSet(country) {
    var date = new Date();
    var agCookie = {
        date: date.toString(),
        country: country
    }
    Cookies.set('AgeGate', JSON.stringify(agCookie), { expires: 30 });
}


function jumpToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').scrollTop(aTag.offset().top);
}
function jumpToAnchorID(aId) {
    var aTag = $("#" + aId);
    $('html,body').scrollTop(aTag.offset().top);
}
function jumpToAnchorIDOffset(aId) {
    var aTag = $("#" + aId);
    $('html,body').scrollTop(aTag.offset().top - scrollToAnchorOffSet);
}
function scrollToAnchor(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}
function scrollToAnchorID(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top }, 'slow');
}

function scrollToAnchorOffset(aName) {
    var aTag = $("a[name='" + aName + "']");
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}
function scrollToAnchorIDOffset(aId) {
    var aTag = $("#" + aId);
    $('html,body').animate({ scrollTop: aTag.offset().top - scrollToAnchorOffSet }, 'slow');
}

function isEmptyOrSpaces(str) {
    if (str === undefined) { return true; }
    return str === null || str.match(/^ *$/) !== null;
}

function nodeListToIds(list) {
    //console.log(' node list : %o', list);
    let nodeIds = [];
    if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {

            var itm = list[i];
            //console.log('%o - %o', itm, itm.checked);
            if (itm.checked) {
                nodeIds.push(itm.value);
            }
        }
    }
    //console.log('node ids : %o', nodeIds);
    return nodeIds; 
}